// @ts-nocheck
import StyledWrapper, { getStyledWrapper } from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Checkbox, { CheckboxPresentationProps } from "@insite/mobius/Checkbox";
import Clickable, { ClickableLinkProps } from "@insite/mobius/Clickable";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Search from "@insite/mobius/Icons/Search";
import LazyImage from "@insite/mobius/LazyImage";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import LoadingSpinner, { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import Popover, {
    ContentBodyProps,
    OverflowWrapperProps,
    PopoverPresentationProps,
    PositionStyle,
} from "@insite/mobius/Popover";
import Select from "@insite/mobius/Select";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import AnchorHeading, { AnchorHeadingStyles } from "@store/Library/Components/Toolkit/Anchor/AnchorHeading";
import InfosBox from "@store/Library/Components/Toolkit/InfosBox";
import { autocompleteFontStyles } from "@store/Themes/common/mixins/autocomplete";
import { imageStyles } from "@store/Themes/common/mixins/image";
import { linkActionStyles, linkStyles } from "@store/Themes/common/mixins/link";
import { typographyTitleStyles } from "@store/Themes/common/mixins/typography";
import { buttonGetFieldIconProps } from "@store/Themes/common/props/button";
import { formGridProps } from "@store/Themes/common/props/form";
import constants from "@store/constants";
import loadPartsData from "@store/Framework/Store/Store/Data/PartFinder/Handlers/LoadPartsData";
import loadSkus from "@store/Framework/Store/Store/Data/PartFinder/Handlers/LoadSkus";
import resetSkus from "@store/Framework/Store/Store/Data/PartFinder/Handlers/ResetSkus";
import { PackageModel, PartModel, PartsListModel, SkuModel } from "@store/Framework/Types/ApiModels";
import PartFinderList from "@store/Library/Components/PartFinder/PartFinderList";
import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import mergeProps from "@toolkit/Framework/Common/Utilities/mergeProps";
import { pxToRem, pxToRemArray } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { spacingStyles } from "@toolkit/Themes/common/mixins";
import { focusOutlineStyles, focusUpdateStyles } from "@toolkit/Themes/common/mixins/common";
import { gridPresetGapStyles } from "@toolkit/Themes/common/mixins/grid";
import debounce from "lodash/debounce";
import throttle from "lodash/throttle";
import React, { ChangeEvent, useCallback, useEffect, useRef, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const StyledSpan = getStyledWrapper("span");
const fieldsSwitchBreakpoint = "md";
const spacingField = "1em";

const autocompleteGetLinkProps = () => ({
    css: css`
        ${linkStyles("text.link", "text.linkHover", false, true)}
        ${focusUpdateStyles(true)}
        position: relative;
        z-index: 1;
        width: 100%;
        padding: ${pxToRem(5, 20)};
    `,
    typographyProps: {
        ellipsis: true,
        css: css`
            z-index: -1;
            width: 100%;
            text-align: left;
        `,
    },
});

const autocompleteLinkWithImageStyles = () => css`
    display: flex;
    align-items: center;
    gap: ${pxToRem(10)};
`;

const linkWithImageProps: LinkPresentationProps = {
    typographyProps: { css: autocompleteLinkWithImageStyles() },
};

const autocompleteWidthProps = {
    css: css`
        ${breakpointValues(["100%", null, pxToRem(450), pxToRem(500), pxToRem(550)], "width")}
    `,
};

const mapStateToProps = (state: ApplicationState) => {
    const { skus, parts } = state.store.data.partFinder;
    return {
        autoCompleteModelsList: skus,
        selectedModelPartsData: parts,
    };
};

const mapDispatchToProps = {
    loadSkus,
    loadPartsData,
    resetSkus,
};

type Props = WidgetProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & HasProduct;

export interface PartFinderFormStyles {
    container?: GridContainerProps;
    anchorHeading?: AnchorHeadingStyles;
    actionsWrapper?: InjectableCss;
    actionsContainer?: GridContainerProps;
    resultsGridItem?: GridItemProps;
    criticalFilterGridItem?: GridItemProps;
    filterItemsGridItem?: GridItemProps;
    modelGridItem?: GridItemProps;
    modelWrapper?: InjectableCss;
    modelSearchClickableWrapper?: InjectableCss;
    modelNewSearchClickable?: ClickableLinkProps;
    searchInputWrapper?: InjectableCss;
    searchInput?: TextFieldPresentationProps;
    searchInputSpinner?: LoadingSpinnerProps;
    packagesSelectWrapper?: InjectableCss;
    actionsGridItem?: GridItemProps;
    filterTextFieldWrapper?: InjectableCss;
    filterInput?: TextFieldPresentationProps;
    filterCriticalCheckbox?: CheckboxPresentationProps;
    errorMessageTypography?: TypographyPresentationProps;
    spinnerGridItem?: GridItemProps;
    innerSpinnerGridItem?: GridItemProps;
    spinner?: LoadingSpinnerProps;
    autocompletePopover?: PopoverPresentationProps;
    autocompletePopoverWrapper?: OverflowWrapperProps;
    autocompletePopoverContentWrapper?: InjectableCss;
    autocompletePopoverContentBody?: ContentBodyProps;
    autocompleteResultsWrapper?: InjectableCss;
    autocompleteLink?: LinkPresentationProps;
    autocompleteLinkFocused?: LinkPresentationProps;
    autocompleteImageWrapper?: InjectableCss;
    autocompleteInfoWrapper?: InjectableCss;
    autocompleteModelNumber?: TypographyPresentationProps;
    autocompleteModelDescription?: TypographyPresentationProps;
    selectedItemGridItem?: GridItemProps;
    selectedItemLabel?: TypographyPresentationProps;
    selectedItemWrapper?: InjectableCss;
    selectedImageWrapper?: InjectableCss;
    selectedInfoWrapper?: InjectableCss;
    selectedItemNumber?: TypographyPresentationProps;
    selectedItemDescription?: TypographyPresentationProps;
    pdpCtaWrapper?: InjectableCss;
}

export const partFinderFormStyles: PartFinderFormStyles = {
    container: mergeProps<PartFinderFormStyles["container"]>(formGridProps.gridContainer, {
        offsetCss: css`
            flex-direction: column;
            padding-bottom: 3em;
        `,
    }),
    anchorHeading: {
        title: {
            variant: null as any,
            forwardAs: "h2",
            css: css`
                ${typographyTitleStyles(pxToRemArray([20, null, 24]))}
                ${spacingStyles(null, "0.75em")}
                margin-top: 0;
            `,
        },
    },
    actionsWrapper: {
        css: css`
            width: 100%;
        `,
    },
    actionsContainer: {
        gap: 0,
        css: css`
            ${x => gridPresetGapStyles(x.theme.design.form.grid.base)}
            font-weight: ${x => x.theme.design.typography.weight.bold};
        `,
        offsetCss: css`
            align-items: center;
        `,
    },
    resultsGridItem: { width: [6, 6, 2, 5, 5] },
    criticalFilterGridItem: { width: [6, 6, 4, 3, 3] },
    filterItemsGridItem: {
        width: [12, 12, 6, 4, 4],
    },
    modelGridItem: { width: 12 },
    modelWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            gap: ${spacingField};
            width: 100%;
            margin-bottom: ${pxToRem(14)};

            ${breakpoint(fieldsSwitchBreakpoint)} {
                width: auto;
                flex-direction: row;
            }
        `,
    },
    modelSearchClickableWrapper: {
        css: css`
            width: 100%;
        `,
    },
    modelNewSearchClickable: {
        css: css`
            ${linkActionStyles()}
            text-decoration: underline;

            &:hover,
            &:active {
                text-decoration: none;
            }

            ${breakpoint(fieldsSwitchBreakpoint)} {
                padding-top: 3em;
            }
        `,
    },
    searchInputWrapper: mergeProps<PartFinderFormStyles["searchInputWrapper"]>(autocompleteWidthProps, {
        css: css`
            position: relative;
        `,
    }),
    searchInput: {
        ...buttonGetFieldIconProps(Search),
        iconClickableProps: {
            ...buttonGetFieldIconProps(Search).iconClickableProps,
            css: css`
                left: 0;
            `,
        },
        cssOverrides: {
            inputSelect: css`
                padding-right: ${pxToRem(16)};
                padding-left: ${pxToRem(43)};
            `,
        },
    },
    searchInputSpinner: {
        size: 20,
        css: css`
            position: absolute;
            bottom: ${pxToRem(11)};
            right: ${pxToRem(14)};
            pointer-events: none;
        `,
    },
    packagesSelectWrapper: autocompleteWidthProps,
    actionsGridItem: {
        width: 12,
        css: css`
            background-color: ${getColor("common.accent")};
        `,
    },
    filterTextFieldWrapper: {
        css: css`
            ${breakpoint(fieldsSwitchBreakpoint)} {
                margin-left: auto;
            }
        `,
    },
    filterInput: {
        ...buttonGetFieldIconProps(Search),
        iconClickableProps: {
            ...buttonGetFieldIconProps(Search).iconClickableProps,
            css: css`
                left: 0;
            `,
        },
        labelProps: {
            css: css`
                align-self: center;
                padding-top: 0;
            `,
        },
        cssOverrides: {
            inputSelect: css`
                padding-left: ${pxToRem(43)};
            `,
        },
    },
    filterCriticalCheckbox: {
        css: css`
            ${x => x.theme.checkbox.defaultProps?.css}

            ${breakpoint(fieldsSwitchBreakpoint)} {
                padding-left: ${spacingField};
                margin-left: auto;
            }
        `,
    },
    innerSpinnerGridItem: {
        width: 12,
        css: css`
            padding: 1em;
            background-color: ${getColor("common.accent")};
        `,
    },
    errorMessageTypography: { color: "danger" },
    spinnerGridItem: { width: 12 },
    spinner: {
        css: css`
            margin: auto;
        `,
    },
    autocompletePopover: {
        transitionDuration: "short",
        toggle: false,
    },
    autocompletePopoverWrapper: {
        as: "div",
        _height: "auto",
    },
    autocompletePopoverContentBody: {
        as: "div",
        _height: "none",
        css: css`
            right: 50%;
            top: 100%;
            box-shadow: none;
            overflow: visible;
            min-width: 100%;
            color: inherit;
            background-color: transparent;
            transform: translateX(50%);
            transition: none;

            ${breakpoint("sm", "down")} {
                max-width: 100%;
            }
        `,
    },
    autocompletePopoverContentWrapper: mergeProps<PartFinderFormStyles["autocompletePopoverContentWrapper"]>(
        autocompleteWidthProps,
        {
            css: css`
                ${autocompleteFontStyles()}
                background-color: ${getColor("common.background")};

                ${({ theme }) => css`
                    box-shadow: ${theme.shadows.e60};
                `}
            `,
        },
    ),
    autocompleteResultsWrapper: {
        css: css`
            overflow-y: auto;
            max-height: 50vh;
        `,
    },
    autocompleteLink: mergeProps<PartFinderFormStyles["autocompleteLink"]>(
        autocompleteGetLinkProps(),
        linkWithImageProps,
    ),
    autocompleteLinkFocused: mergeProps<PartFinderFormStyles["autocompleteLinkFocused"]>(autocompleteGetLinkProps(), {
        ...linkWithImageProps,
        css: css`
            color: ${getColor("primary")};

            &:not(:focus-visible) {
                ${x => focusOutlineStyles(`-${x.theme.focus.width}`)}
            }
        `,
    }),
    autocompleteImageWrapper: {
        css: css`
            ${x => imageStyles(x.theme.design.product.image.small.ratio)}
            width: ${pxToRem(50)};
            flex: 0 0 auto;
        `,
    },
    autocompleteInfoWrapper: {
        css: css`
            display: flex;
            width: 0%;
            flex: 1 0 auto;
            flex-direction: column;
        `,
    },
    autocompleteModelNumber: {
        css: css`
            float: left; /* Prevent underline effect */
        `,
    },
    autocompleteModelDescription: {
        ellipsis: true,
        css: css`
            font-weight: ${x => x.theme.design.typography.weight.bold};
        `,
    },
    selectedItemGridItem: {
        width: 12,
        css: css`
            padding-top: 1em;
            background-color: ${getColor("common.accent")};

            > div {
                width: 100%;
                padding: 0.25em 0 1em 0;
                border-bottom: ${pxToRem(2)} solid ${getColor("common.borderLight")};
            }
        `,
    },
    selectedItemLabel: {
        css: css`
            font-weight: ${x => x.theme.design.typography.weight.bold};
        `,
    },
    selectedItemWrapper: {
        css: css`
            display: flex;
            margin-top: ${pxToRem(6)};
            padding: ${pxToRem(12)};
            border: ${pxToRem(1)} solid ${getColor("common.border")};
            background: ${getColor("header.main")};
            max-width: ${pxToRem(370)};
        `,
    },
    selectedImageWrapper: {
        css: css`
            ${x => imageStyles(x.theme.design.product.image.small.ratio)}
            width: ${pxToRem(50)};
            flex: 0 0 auto;
            margin-right: ${pxToRem(12)};
        `,
    },
    selectedInfoWrapper: {
        css: css`
            display: flex;
            width: 0%;
            flex: 1 0 auto;
            flex-direction: column;
        `,
    },
    selectedItemNumber: {
        css: css`
            float: left; /* Prevent underline effect */
        `,
    },
    selectedItemDescription: {
        css: css`
            font-weight: ${x => x.theme.design.typography.weight.bold};
        `,
    },
    pdpCtaWrapper: {
        css: css`
            margin-top: 0.5em;
            margin-bottom: 1em;
        `,
    },
};

const styles = partFinderFormStyles;
const minSearchCharacters = 3;
const PartFinderForm = ({
    autoCompleteModelsList,
    selectedModelPartsData,
    product,
    loadSkus,
    loadPartsData,
    resetSkus,
}: Props) => {
    const trackForm = ga.use.trackEvent({ action: "gaEvent" });
    const [filterProductFilterString, setFilterProductFilterString] = useState<string>("");
    const [modelSearch, setModelNameSearch] = useState("");
    const [searchPartsQuery, setSearchPartsQuery] = useState("");
    const [selectedProductDescription, setSelectedProductDescription] = useState("");
    const [selectedProductImage, setSelectedProductImage] = useState("");
    const [selectedProductsalesPackageId, setSelectedProductsalesPackageId] = useState("");
    const [isLoadingModels, setIsLoadingModels] = useState(false);
    const [showModelsResults, setShowModelsResults] = useState(false);
    const [isLoadingParts, setIsLoadingParts] = useState(false);
    const [isLoadingFiltering, setIsLoadingFiltering] = useState(false);
    const [isFilteringCritical, setIsFilteringCritical] = useState(false);
    const [currentPackage, setCurrentPackage] = useState<PackageModel>();
    const [filteredPackage, setFilteredPackage] = useState<PackageModel>();
    const autocompletePopoverRef = useRef(null);
    const autocompleteListRef = useRef<HTMLUListElement>();
    const [autocompleteFocusableItems, setAutocompleteFocusableItems] = useState<SkuModel[]>([]);
    const [autocompleteFocusableItem, setAutocompleteFocusableItem] = useState<SkuModel>();
    const searchInputRef = useRef({ value: "" } as HTMLInputElement);
    const partsTotal = React.useMemo(() => {
        return filteredPackage?.groups.reduce((total, item) => {
            const partsLength = item.parts?.length || 0;
            const kitModelsLength =
                item.parts?.reduce((kitTotal, part) => {
                    return kitTotal + (part.kitModels?.length || 0);
                }, 0) || 0;
            return total + partsLength + kitModelsLength;
        }, 0);
    }, [filteredPackage]);
    const searchFieldId = "partFinderId";

    const getAllProducts = (listName: string, groups: any) => {
        const partsArray: any[] = [];
        groups.forEach((group: { parts: { id: string; [key: string]: any }[] }) => {
            group.parts.forEach(part => {
                if (
                    part.id !== "00000000-0000-0000-0000-000000000000" &&
                    !partsArray.some((existingPart: any) => existingPart.item_id === part.number)
                ) {
                    const model = {
                        item_id: part.number,
                        item_name: part.name,
                        stock_id: part.availabilityStatus?.status,
                        stock_status: part.availabilityStatus?.statusName,
                        item_list_id: "partslist",
                        item_list_name: listName,
                        page_type: "Parts List",
                    };
                    partsArray.push(model);
                }
            });
        });
        return partsArray;
    };

    useEffect(() => {
        if (selectedModelPartsData?.packages && selectedModelPartsData.packages?.length > 0) {
            setIsFilteringCritical(false);
            setCurrentPackage(selectedModelPartsData?.packages[0]);
            setFilteredPackage(selectedModelPartsData?.packages[0]);
        }
    }, [selectedModelPartsData]);

    useEffect(() => {
        return () => {
            setIsFilteringCritical(false);
            setCurrentPackage(undefined);
            setFilteredPackage(undefined);
            setFilterProductFilterString("");
            resetSkus();
        };
    }, []);

    useEffect(() => {
        if (product && product.properties.showPartsTab.toLowerCase() !== "true") {
            return;
        }
        if (product) {
            setIsLoadingParts(true);
            setSelectedProductDescription(product.productTitle);
            loadPartsData({
                id: product.id,
                onSuccess: (result: PartsListModel) => {
                    if (result.packages && result.packages[0]) {
                        const partsArray = getAllProducts(product.id, result.packages[0].groups);
                        trackForm({
                            eventCategory: "Parts List",
                            eventAction: "Search",
                            eventLabel: product.id,
                            items: partsArray,
                        });
                    }
                },
                onComplete: () => {
                    setIsLoadingParts(false);
                },
            });
        }
    }, [product?.id]);

    useEffect(() => {
        if (autoCompleteModelsList) {
            if (autoCompleteModelsList.length === 0) {
                setFilteredPackage(undefined);
                setSelectedProductDescription(product?.productTitle || "");
                setSelectedProductImage("");
                setSelectedProductsalesPackageId("");
            }

            if (autoCompleteModelsList.length === 1) {
                setIsLoadingParts(true);
                setSelectedProductDescription(autoCompleteModelsList[0].description);
                setSelectedProductImage(autoCompleteModelsList[0].imageUrl);
                setSelectedProductsalesPackageId(autoCompleteModelsList[0].salesPackageId);
                loadPartsData({
                    sku: autoCompleteModelsList[0].salesPackageId,
                    onSuccess: (result: PartsListModel) => {
                        if (result.packages && result.packages[0]) {
                            const partsArray = getAllProducts(
                                autoCompleteModelsList[0].salesPackageId,
                                result.packages[0].groups,
                            );
                            trackForm({
                                eventCategory: "Parts List",
                                eventAction: "Search",
                                eventLabel: autoCompleteModelsList[0].salesPackageId,
                                items: partsArray,
                            });
                        }
                        setIsLoadingParts(false);
                    },
                });
            }
        }
    }, [autoCompleteModelsList]);

    const debouncedSearchModel = useCallback(
        debounce((query: string) => {
            setIsLoadingModels(true);
            loadSkus({
                id: query,
                onSuccess: result => {
                    setAutocompleteFocusableItems(result);
                    setIsLoadingModels(false);
                    setShowModelsResults(true);
                    setFilterProductFilterString("");
                },
            });
        }, 1000),
        [loadSkus],
    );

    // Even when tranformed in URL format in the API service, these characters wont make it through the API on server side.
    const searchInvalidCharacters = ["*", ":", "?", "%", "&", "$"];

    const getInvalidCharactersAsString = () => {
        return searchInvalidCharacters.join(" ");
    };

    const containsInvalidCharacter = (input: string) => {
        return searchInvalidCharacters.some(char => input.includes(char));
    };

    const hasNoMatchingModels = () => {
        return (
            (product?.id && autoCompleteModelsList?.length === 0 && !isLoadingModels) ||
            (modelSearch.length >= minSearchCharacters &&
                autoCompleteModelsList?.length === 0 &&
                showModelsResults &&
                !isLoadingModels)
        );
    };

    const invalidCharacterValidation = () => {
        return modelSearch.length >= minSearchCharacters && containsInvalidCharacter(modelSearch);
    };

    const canLoadSkus = () => {
        return !isLoadingModels && modelSearch.length >= minSearchCharacters && !containsInvalidCharacter(modelSearch);
    };

    const getErrorMessageOnError = () => {
        if (invalidCharacterValidation()) {
            return translate(
                `The following characters should be removed from search query : ${getInvalidCharactersAsString()}`,
            );
        }

        if (hasNoMatchingModels()) {
            return translate("We could not find any models matching your search criterias");
        }

        return undefined;
    };

    const onModelInputChanged = (event: ChangeEvent<HTMLInputElement>) => {
        setModelNameSearch(event.target.value);
        if (event.target.value.length >= minSearchCharacters && !containsInvalidCharacter(event.target.value)) {
            debouncedSearchModel(event.target.value);
        }

        if (event.target.value.length === 0) {
            setShowModelsResults(false);
        }
    };

    const partMatchQuery = (part: PartModel, query: string) => {
        return (
            part.number?.toLowerCase().indexOf(query || "") !== -1 ||
            part.name?.toLowerCase().indexOf(query || "") !== -1
        );
    };

    const searchParts = (query: string, filterCritical?: boolean) => {
        setIsLoadingFiltering(true);
        if (currentPackage) {
            setFilteredPackage({ ...currentPackage });
        }

        if (query === "") {
            if (filterCritical) {
                filterCriticalParts();
            }
            setTimeout(() => {
                setIsLoadingFiltering(false);
            }, 250);
            return;
        }
        setFilteredPackage({ ...currentPackage, groups: [] });

        currentPackage?.groups?.forEach(group => {
            let filteredParts = group.parts?.filter(part => {
                return partMatchQuery(part, query);
            });

            if (filterCritical) {
                filteredParts = filteredParts?.filter(part => {
                    return part.isCritical === true;
                });
            }

            let uniqueParts: PartModel[] = [];
            filteredParts?.forEach(filteredPart => {
                let isDuplicate = false;
                uniqueParts = uniqueParts.map(uniquePart => {
                    if (uniquePart.number === filteredPart.number) {
                        isDuplicate = true;
                        return { ...uniquePart, quantity: uniquePart.quantity + filteredPart.quantity };
                    }
                    return uniquePart;
                });

                if (!isDuplicate) {
                    uniqueParts = [...uniqueParts, filteredPart];
                }
            });
            if (filteredPackage && uniqueParts.length > 0) {
                setFilteredPackage(prevState => ({
                    ...prevState,
                    groups: [...prevState!.groups, { name: group.name, parts: uniqueParts }],
                }));
            }
        });
        setTimeout(() => {
            setIsLoadingFiltering(false);
        }, 250);
    };

    const debouncedSearchParts = useCallback(
        debounce((query: string) => {
            setSearchPartsQuery(query);
            searchParts(query, isFilteringCritical);
        }, 150),
        [searchParts],
    );

    const onPartsFilterInputChanged = (event: ChangeEvent<HTMLInputElement>) => {
        setFilterProductFilterString(event.target.value.toLowerCase());
        debouncedSearchParts(event.target.value.toLowerCase());
    };

    const modelChangeHandler = (event: ChangeEvent<HTMLSelectElement>) => {
        setFilterProductFilterString("");
        setIsLoadingParts(true);
        setSelectedProductDescription(event.target.value);
        loadPartsData({
            sku: event.target.value,
            onSuccess: (result: PartsListModel) => {
                if (result.packages && result.packages[0]) {
                    const partsArray = getAllProducts(event.target.value, result.packages[0].groups);
                    trackForm({
                        eventCategory: "Parts List",
                        eventAction: "Search",
                        eventLabel: event.target.value,
                        items: partsArray,
                    });
                }
                setIsLoadingParts(false);
            },
        });
    };

    const filterCriticalParts = () => {
        if (currentPackage) {
            setFilteredPackage({ ...currentPackage });
        }
        setFilteredPackage({ ...currentPackage, groups: [] });

        currentPackage?.groups?.forEach(group => {
            const filteredParts = group.parts?.filter(part => {
                return part.isCritical === true;
            });

            if (filteredPackage && filteredParts && filteredParts.length > 0) {
                setFilteredPackage(prevState => ({
                    ...prevState,
                    groups: [...prevState!.groups, { name: group.name, parts: filteredParts }],
                }));
            }
        });
    };

    const handleCriticalFilterCheckbox = (event: React.SyntheticEvent<Element, Event>, value: boolean) => {
        setIsFilteringCritical(value);
        searchParts(searchPartsQuery, value);
    };

    const autocompleteLinkHandler = (model: { description: string; imageUrl: string; salesPackageId: string }) => {
        closeAutocompletePopover();
        setIsLoadingParts(true);
        setSelectedProductDescription(model.description);
        setSelectedProductImage(model.imageUrl);
        setSelectedProductsalesPackageId(model.salesPackageId);
        setFilterProductFilterString("");
        loadPartsData({
            sku: model.salesPackageId,
            onSuccess: (result: PartsListModel) => {
                if (result.packages && result.packages[0]) {
                    const partsArray = getAllProducts(model.salesPackageId, result.packages[0].groups);
                    trackForm({
                        eventCategory: "Parts List",
                        eventAction: "Search",
                        eventLabel: model.salesPackageId,
                        items: partsArray,
                    });
                }
                setIsLoadingParts(false);
            },
        });
    };

    const autocompleteMoveFocus = throttle((direction: "prev" | "next") => {
        const focusableQueue =
            direction === "prev" ? autocompleteFocusableItems.slice().reverse() : autocompleteFocusableItems;
        const focusedIndex = focusableQueue.indexOf(autocompleteFocusableItem as SkuModel);
        const newFocusedOption = focusableQueue.find((_, index) => index > focusedIndex);
        setAutocompleteFocusableItem(newFocusedOption);
    }, 100);

    const autocompletePopoverCloseHandler = () => {
        setAutocompleteFocusableItem(undefined);
    };

    const closeAutocompletePopover = () => {
        autocompletePopoverRef.current && (autocompletePopoverRef.current! as any).closePopover();
    };

    const autocompletePopoverKeyDownHandler = (event: KeyboardEvent) => {
        switch (event.key) {
            case "ArrowDown":
                autocompleteMoveFocus("next");
                break;
            case "ArrowUp":
                autocompleteMoveFocus("prev");
                break;
            case "Enter":
                if (autocompleteFocusableItem) {
                    autocompleteLinkHandler(autocompleteFocusableItem);
                }
                break;
            default:
                break;
        }
    };

    const getAutocompletePopoverPosition = () => {
        const positionStyle: PositionStyle = {
            position: "absolute",
        };

        return positionStyle;
    };

    const newSearchHandler = () => {
        setShowModelsResults(false);
        setIsLoadingModels(false);
        closeAutocompletePopover();
        setAutocompleteFocusableItem(undefined);
        setModelNameSearch("");

        if (searchInputRef.current?.value) {
            searchInputRef.current.value = "";
        }
    };

    if (product && product.properties.showPartsTab.toLowerCase() !== "true") {
        return null;
    }

    const searchInput = (
        <StyledWrapper {...styles.searchInputWrapper}>
            <TextField
                {...styles.searchInput}
                label={translate("Search for a model")}
                placeholder={translate("Store_PartFinder_SearchPlaceholder")}
                onChange={onModelInputChanged}
                iconClickableProps={{
                    onClick: () => (canLoadSkus() ? loadSkus({ id: modelSearch }) : () => {}),
                    ...styles.searchInput?.iconClickableProps,
                }}
                error={getErrorMessageOnError()}
                id={searchFieldId}
                type="search"
                ref={searchInputRef}
            />
            {isLoadingModels && <LoadingSpinner {...styles.searchInputSpinner} />}
        </StyledWrapper>
    );
    return (
        <>
            {product ? (
                <AnchorHeading
                    title={translate("Equipment Parts List")}
                    anchor={translate("equipment_parts_list")}
                    label={translate("Equipment Parts List")}
                    extendedStyles={styles.anchorHeading}
                />
            ) : null}
            <GridContainer {...styles.container}>
                <GridItem {...styles.modelGridItem}>
                    {!product ? (
                        <StyledWrapper {...styles.modelWrapper}>
                            <Popover
                                {...styles.autocompletePopover}
                                controlsId={`${searchFieldId}-popover`}
                                ref={autocompletePopoverRef}
                                insideRefs={[autocompleteListRef]}
                                popoverTrigger={searchInput}
                                positionFunction={getAutocompletePopoverPosition}
                                wrapperProps={styles.autocompletePopoverWrapper}
                                contentBodyProps={
                                    {
                                        ref: autocompleteListRef,
                                        ...styles.autocompletePopoverContentBody,
                                    } as any
                                }
                                handleKeyDown={autocompletePopoverKeyDownHandler}
                                onClose={autocompletePopoverCloseHandler}
                            >
                                {showModelsResults &&
                                    !isLoadingModels &&
                                    modelSearch.length >= minSearchCharacters &&
                                    autoCompleteModelsList &&
                                    autoCompleteModelsList.length > 1 && (
                                        <StyledWrapper {...styles.autocompletePopoverContentWrapper}>
                                            <StyledWrapper {...styles.autocompleteResultsWrapper}>
                                                <ul>
                                                    {autoCompleteModelsList.map((model, i) => {
                                                        return (
                                                            <li key={`${model.description}-${i}`}>
                                                                <Link
                                                                    onClick={() => autocompleteLinkHandler(model)}
                                                                    {...(autocompleteFocusableItem === model
                                                                        ? styles.autocompleteLinkFocused
                                                                        : styles.autocompleteLink)}
                                                                >
                                                                    <StyledSpan
                                                                        {...styles.autocompleteImageWrapper}
                                                                        aria-hidden={true}
                                                                    >
                                                                        <LazyImage src={model.imageUrl} altText="" />
                                                                    </StyledSpan>
                                                                    <StyledSpan {...styles.autocompleteInfoWrapper}>
                                                                        <Typography {...styles.autocompleteModelNumber}>
                                                                            {model.salesPackageId}
                                                                        </Typography>
                                                                        <Typography
                                                                            {...styles.autocompleteModelDescription}
                                                                        >
                                                                            {model.description}
                                                                        </Typography>
                                                                    </StyledSpan>
                                                                </Link>
                                                            </li>
                                                        );
                                                    })}
                                                </ul>
                                            </StyledWrapper>
                                        </StyledWrapper>
                                    )}
                            </Popover>
                            <StyledWrapper {...styles.modelSearchClickableWrapper}>
                                <Clickable
                                    onClick={newSearchHandler}
                                    {...styles.modelNewSearchClickable}
                                    disabled={
                                        isLoadingModels || isLoadingParts || modelSearch.length < minSearchCharacters
                                    }
                                >
                                    {translate("Make a new search")}
                                </Clickable>
                            </StyledWrapper>
                        </StyledWrapper>
                    ) : !isLoadingModels &&
                      selectedModelPartsData?.packages &&
                      selectedModelPartsData?.packages?.length > 0 ? (
                        <StyledWrapper {...styles.packagesSelectWrapper}>
                            <Select
                                label={translate("Store_ProductDetail_PartsList_Model")}
                                name="modelList"
                                onChange={modelChangeHandler}
                                value={selectedProductDescription}
                            >
                                {selectedModelPartsData?.packages?.map(partsPackage => {
                                    return (
                                        <option key={partsPackage.number} value={partsPackage.number}>
                                            {partsPackage.number}
                                        </option>
                                    );
                                })}
                            </Select>
                        </StyledWrapper>
                    ) : (
                        <>
                            {!isLoadingParts && (
                                <Typography {...styles.errorMessageTypography}>
                                    {translate("Store_ProductDetail_PartsList_NoDataAvailable")}
                                </Typography>
                            )}
                        </>
                    )}
                </GridItem>
                {selectedModelPartsData &&
                    selectedModelPartsData?.packages &&
                    selectedModelPartsData?.packages?.length < 1 && (
                        <GridItem {...styles.modelGridItem}>
                            <Typography {...styles.errorMessageTypography}>
                                {translate("We could not find any models matching your search criterias")}
                            </Typography>
                        </GridItem>
                    )}
                {selectedModelPartsData &&
                    selectedModelPartsData?.packages &&
                    selectedModelPartsData?.packages?.length > 0 &&
                    selectedProductDescription && (
                        <>
                            {!product &&
                                selectedProductImage &&
                                selectedProductsalesPackageId &&
                                selectedProductDescription && (
                                    <GridItem {...styles.selectedItemGridItem}>
                                        <StyledWrapper>
                                            <Typography {...styles.selectedItemLabel}>
                                                {translate("Selected model:")}
                                            </Typography>
                                            <StyledWrapper {...styles.selectedItemWrapper}>
                                                <StyledSpan {...styles.selectedImageWrapper}>
                                                    <LazyImage src={selectedProductImage} altText="" />
                                                </StyledSpan>
                                                <StyledSpan {...styles.selectedInfoWrapper}>
                                                    <Typography {...styles.selectedItemNumber}>
                                                        {selectedProductsalesPackageId}
                                                    </Typography>
                                                    <Typography {...styles.selectedItemDescription}>
                                                        {selectedProductDescription}
                                                    </Typography>
                                                </StyledSpan>
                                            </StyledWrapper>
                                        </StyledWrapper>
                                    </GridItem>
                                )}
                            {product && (
                                <StyledWrapper {...styles.pdpCtaWrapper}>
                                    <InfosBox>
                                        {translate("Store_ProductDetail_PartFinder_Link_Description")}{" "}
                                        <Link href="/part-finder">
                                            {translate("Store_ProductDetail_PartFinder_Link")}
                                        </Link>
                                    </InfosBox>
                                </StyledWrapper>
                            )}
                            <GridItem {...styles.actionsGridItem}>
                                <StyledWrapper {...styles.actionsWrapper}>
                                    <GridContainer {...styles.actionsContainer}>
                                        <GridItem {...styles.resultsGridItem}>
                                            {translate("Results:")}{" "}
                                            {partsTotal && `${partsTotal} ${translate("parts")}`}
                                        </GridItem>
                                        <GridItem {...styles.criticalFilterGridItem}>
                                            <Checkbox
                                                checked={isFilteringCritical}
                                                onChange={handleCriticalFilterCheckbox}
                                                {...styles.filterCriticalCheckbox}
                                                disabled={isLoadingParts}
                                            >
                                                {translate("Show only Critical Parts")}
                                            </Checkbox>
                                        </GridItem>
                                        <GridItem {...styles.filterItemsGridItem}>
                                            <StyledWrapper {...styles.filterTextFieldWrapper}>
                                                <TextField
                                                    labelPosition="left"
                                                    value={filterProductFilterString}
                                                    label={translate("Store_ProductDetail_PartsList_Filter")}
                                                    onChange={onPartsFilterInputChanged}
                                                    placeholder={translate(
                                                        "Store_ProductDetail_PartsList_FilterPlaceholder",
                                                    )}
                                                    disabled={isLoadingParts}
                                                    type="search"
                                                    {...styles.filterInput}
                                                />
                                            </StyledWrapper>
                                        </GridItem>
                                    </GridContainer>
                                </StyledWrapper>
                            </GridItem>
                            {filteredPackage &&
                            filteredPackage?.number !== undefined &&
                            selectedModelPartsData?.packages &&
                            selectedModelPartsData?.packages[0].number === filteredPackage?.number &&
                            !isLoadingParts &&
                            !isLoadingFiltering ? (
                                <PartFinderList packageModel={filteredPackage} />
                            ) : (
                                <GridItem {...styles.innerSpinnerGridItem}>
                                    <LoadingSpinner {...styles.spinner} />
                                </GridItem>
                            )}
                        </>
                    )}
                {isLoadingParts && !selectedModelPartsData && (
                    <GridItem {...styles.spinnerGridItem}>
                        <LoadingSpinner {...styles.spinner} />
                    </GridItem>
                )}
            </GridContainer>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withProduct(PartFinderForm)),
    definition: {
        displayName: "Part Finder Form",
        group: constants.widgetGroup.partFinder,
    },
};

export default widgetModule;
